<template>
  <div>
    <div class="token-help-text">
      <a
        href="javascript:void(0)"
        role="button"
        @click="showTokenHelpModal = true"
        class="theme-font-medium text-nowrap text-decoration-none"
        >Token help
      </a>
    </div>
    <TokenHelpModal
      v-if="showTokenHelpModal"
      :token-type="tokenType"
      @hideTokenHelpModal="showTokenHelpModal = false"
    />
  </div>
</template>
<script>
export default {
  name: 'TokenHelp',
  props: {
    tokenType: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      showTokenHelpModal: false
    }
  },
  components: {
    TokenHelpModal: () => import('./TokenHelpModal.vue')
  }
}
</script>
